import { render, staticRenderFns } from "./StudentLearningIdentityListPage.vue?vue&type=template&id=7bf6215c&scoped=true"
import script from "./StudentLearningIdentityListPage.vue?vue&type=script&lang=js"
export * from "./StudentLearningIdentityListPage.vue?vue&type=script&lang=js"
import style1 from "./StudentLearningIdentityListPage.vue?vue&type=style&index=1&id=7bf6215c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf6215c",
  null
  
)

export default component.exports